export const mobileMaxWidth = '932px'; // Remember to update also the value in _variables.scss
